export enum CLIENTS_KEYS {
  ALL = 'clients',
  CLIENT_ALLOWED_CASHIER_PMS = 'client_allowed_cashier_pms',
  CLIENT_INFO = 'client_info',
  CLIENT_INSTRUMENT = 'client_instrument',
  CLIENT_PAGE_LIMIT = 'client_page_limit',
  CLIENT_PAGE_LIMITS = 'client_page_limits',
  CLIENT_PAYMENT_METHOD = 'client_payment_method',
  CLIENT_PRIORITY_RULESETS = 'client_priority_rulesets',
  CLIENT_ROUTING_PAYMENT_INSTRUMENTS = 'client_routing_payment_instruments',
  CLIENT_ROUTING_PRIORITIES = 'client_routing_priorities',
  CLIENT_ROUTING_STATS = 'client_routing_stats',
  CLIENT_SAVED_CARD_TOKENS = 'client_saved_card_tokens',
  CLIENT_STATS = 'client_stats',
  CLIENT_TOP_ERRORS = 'client_top_errors',
  CLIENTS_ALL_INSTRUMENTS = 'clients_all_instruments',
  CLIENTS_LIMITS = 'clients_limits',
  CLIENTS_UNIQUE_PAYMENT_INSTRUMENTS = 'clients_unique_payment_instruments',
}

export const INITIAL_OFF_COLUMNS_CLIENTS = [
  'merchantTerminalId',
  'city',
  'countryCode',
  'taxNumber',
  'ip',
  'registrationIp',
  'personalId',
  'phoneCountryCode',
  'phone',
  'gender',
  'addressLine1',
  'addressLine2',
  'postalCode',
];

export const INITIAL_OFF_COLUMNS_CLIENT_INSTRUMENTS = [
  'binLength',
  'cardCategory',
  'cardCountry',
  'cardExpiryDate',
  'cardFullBin',
  'cardIssuingOrganization',
];

export const MAIN_COLUMNS = ['merchantCustomerId'];
